import styled from 'styled-components';
import Lightbox from 'yet-another-react-lightbox';
import colors from '../../atomic-design/theme/constants/colors';
import breakpoints from '../../atomic-design/theme/constants/breakpoints';

const StyledNavigationBtn = `
display: none;

@media only screen and ${breakpoints.device.s} {
  display: block;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  background: #efefef;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }

  &:focus {
    outline: none;
  }
  
  &::before {
    content: '';
    display: block;
    width: 18px;
    height: 18px;
    border: 2px solid ${colors.black};
    margin: auto;
    position: absolute;
    top: 21px;
    left: 21px;
  }
}
`;

export const StyledLightbox = styled(Lightbox)`
  .yarl__container {
    background-color: rgba(21, 33, 47, 0.75);
  }

  .yarl__toolbar {
    padding-top: 0;

    button {
      opacity: 0.7;
      &:hover {
        background: ${colors.red100};
        opacity: 1;
        filter: none;
      }

      &:focus {
        outline: none;
      }

      &:disabled {
        pointer-events: none;
      }
    }
  }

  .yarl__button.yarl__navigation_prev {
    ${StyledNavigationBtn}

    svg {
      display: none;
    }

    &::before {
      border-bottom: none;
      border-right: none;
      transform: translate3d(3px, 0, 0) rotate(-45deg);
    }
  }

  .yarl__button.yarl__navigation_next {
    ${StyledNavigationBtn}

    svg {
      display: none;
    }

    &::before {
      border-bottom: none;
      border-left: none;
      transform: translate3d(-3px, 0, 0) rotate(45deg);
    }
  }
`;
